module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/desktop-app-3-3b2ac4622d9fad7f5b65747fb8207d62.png";